// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M17 7C20.866 7 24 10.134 24 14L23.9912 14.3604C23.8097 17.9395 20.9395 20.8097 17.3604 20.9912L17 21C13.2549 21 10.1963 18.0589 10.0088 14.3604L10 14C10 10.134 13.134 7 17 7ZM16 14.4141L18.333 16.7471L19.7471 15.333L18 13.5859V11.3359H16V14.4141Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8 20H0V18H8V20Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8 15H0V13H8V15Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8 10H0V8H8V10Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M24 5H0V3H24V5Z"}}]};

const DialogHistoryFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'dialog-history-filled',
    ref,
    icon: element,
  },
));

DialogHistoryFilledIcon.displayName = 'DialogHistoryFilledIcon';

export default DialogHistoryFilledIcon;
